(function(){
'use strict';
window.OXX_FINDER_INDEX_READY = false;
window.OXX_FINDER_INDEX = null;

function norm(v){ return String(v || '').replace(/×/g,'x').replace(/[，,]/g,' ').replace(/\s+/g,' ').trim(); }
function num(v){ var m = norm(v).match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : null; }
function fmt2(v){ var n = typeof v === 'number' ? v : num(v); return n !== null && isFinite(n) ? n.toFixed(2) : ''; }
function material(v){
  var u = norm(v).toUpperCase();
  if (u.indexOf('FFKM') !== -1) return 'FFKM';
  if (u.indexOf('FKM') !== -1) return 'FKM';
  if (u.indexOf('EPDM') !== -1) return 'EPDM';
  if (u.indexOf('SILICONE') !== -1) return 'SILICONE';
  if (u.indexOf('NBR') !== -1) return 'NBR';
  return '';
}
function hardness(v){
  var m = norm(v).toUpperCase().match(/(?:^|\D)(50|60|70|75|80|90)\s*(?:A|SHA|SHORE\s*A)?(?:\D|$)/);
  return m ? m[1] : '';
}
function searchUrl(q){ return '/search?q=' + encodeURIComponent(norm(q)) + '&type=product'; }
function lookup(id, cs, mat, hard){
  var index = window.OXX_FINDER_INDEX;
  if (!index || !index.exact) return '';
  var key = fmt2(id) + '|' + fmt2(cs) + '|' + material(mat) + '|' + hardness(hard);
  return index.exact[key] || '';
}
function standard(q){
  var text = norm(q).toUpperCase();
  var m = text.match(/AS\s*568\s*[-#:]?\s*(\d{1,4})/i);
  if (m) return 'AS568-' + String(m[1]).padStart(3, '0');
  m = text.match(/DIN\s*3771[^,;]*/i);
  if (m) return norm(m[0]);
  m = text.match(/ISO\s*3601[^,;]*/i);
  if (m) return norm(m[0]);
  return '';
}
function sizeQuery(q){
  var text = norm(q);
  var m = text.match(/(\d+(?:\.\d+)?)\s*(?:x|\*)\s*(\d+(?:\.\d+)?)/i);
  if (!m) return {id:null, cs:null};
  var id = parseFloat(m[1]), cs = parseFloat(m[2]);
  if (/\b(in|inch|inches|")\b/i.test(text)) { id = id * 25.4; cs = cs * 25.4; }
  return {id:id, cs:cs};
}
function route(q){
  q = norm(q);
  if (!q) return '';
  var st = standard(q);
  if (st) return searchUrl(st);
  var s = sizeQuery(q), m = material(q), h = hardness(q);
  if (s.id !== null && s.cs !== null) {
    if (m && h) {
      var handle = lookup(s.id, s.cs, m, h);
      if (handle) return '/products/' + handle;
    }
    return searchUrl(q);
  }
  return '';
}

window.oxxFinderLookup = lookup;
window.oxxFinderRoute = route;
window.oxxFinderSearchUrl = searchUrl;

var url = window.OXX_FINDER_INDEX_URL;
if (url) {
  fetch(url, { credentials: 'same-origin' })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(data){
      if (data && data.exact) {
        window.OXX_FINDER_INDEX = data;
        window.OXX_FINDER_INDEX_READY = true;
      }
    })
    .catch(function(){ window.OXX_FINDER_INDEX_READY = false; });
}
})();